<template>
  <div class="vx-col w-full mb-base">
    <!--<h4 class="custom-title">Application Details</h4>-->
    <vx-card title="Application Details">
      <template slot="actions">
        <vs-button class="mb-4" v-if="purchaseApp.status === 5" color="success" @click="popupActive2=true">Reprocess</vs-button>
      </template>
    </vx-card>
    <vx-card>
      <div v-if="!user.status" class="vx-row w-full">
        <vs-alert color="danger" title="Warning : Blacklisted" active="true">
          This applicant is blacklisted.
        </vs-alert>
        <br>
      </div>
      <div v-if="purchaseApp.status === 7" class="vx-row w-full">
          <vs-alert color="success" title="Reviewer Comments" active="true">
            {{purchaseApp.comment}}
          </vs-alert>
<!--          <vs-alert color="success" title="Invoice Number" active="true">-->
<!--            {{purchaseApp.invoice_number}}-->
<!--          </vs-alert>-->
      </div>
    </vx-card>
    <br>
      <div class="w-full">
        <vx-card title="Purchase Information">
          <div id="data-list-list-view" class="data-list-container">
            <table ref="table" class="table-auto">
                <tbody>
                <tr>
                  <th sort-key="name">Product Name</th>
                  <td>
                    <p class="product-name font-medium truncate">
                      {{ product.product }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <th sort-key="name">Brand</th>
                  <td>
                    <p class="product-name font-medium truncate">
                      {{ purchaseApp.brand }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <th sort-key="name">Price Range</th>
                  <td>
                    <p class="product-name font-medium truncate">
                      {{ purchaseApp.price_range }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <th sort-key="order_status">Application Status</th>
                  <td>
                    <vs-chip
                      :color="getOrderStatusColor(purchaseApp.status)"
                      class="product-order-status"
                    >
                      {{purchaseApp.status == '2' ? 'New Application': purchaseApp.status == '3'? 'In-Process':
                      purchaseApp.status == '4' ? 'Halt' : purchaseApp.status == '5'? 'Accepted': purchaseApp.status ==
                      '6'? 'Rejected' : purchaseApp.status == '7'? 'Reviewed':''}}
                    </vs-chip>
                  </td>
                </tr>
                </tbody>
            </table>
          </div>
        </vx-card>
      </div>
      <br/>
      <div class="w-full">
          <vx-card title="Applicant Personal Information" class="mb-base">
            <!-- Avatar -->
            <div class="vx-row">
              <!-- Avatar Col -->
              <div class="vx-col" id="avatar-col">
                <div class="img-container mb-4">
                            <img :src="personal.photo" class="rounded w-full" />
                </div>
              </div>

              <!-- Information - Col 1 -->
              <div class="vx-col flex-1" id="account-info-col-1">
                <table class="table-auto">
                  <tr>
                    <td class="font-semibold">First Name</td>
                    <td>{{ personal.name }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Last Name</td>
                    <td>{{ personal.last_name }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Father’s Name</td>
                    <td>{{ personal.father_name }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Mother’s Name</td>
                    <td>{{ personal.mother_name }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Spouse Name</td>
                    <td>{{ personal.spouse_name }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Age</td>
                    <td>{{ personal.age }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Marital Status</td>
                    <td>{{ personal.marital_status }}</td>
                  </tr>
                </table>
              </div>
              <!-- /Information - Col 1 -->

              <!-- Information - Col 2 -->
              <div class="vx-col flex-1" id="account-info-col-2">
                <table class="table-auto">
                  <tr>
                    <td class="font-semibold">Gender</td>
                    <td>{{ personal.gender }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Head of Household</td>
                    <td>{{ personal.head_of_household === true?'Yes':'No' }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Education Level</td>
                    <td>{{ personal.education_level }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">NID No</td>
                    <td>{{ personal.nid }}</td>
                  </tr>
                  <tr v-if="personal.nid_photo !== null">
                    <td class="font-semibold">Photo from Nid</td>
                    <td><img @click="popupActive11=true" class="nidImg" :src="personal.nid_photo" alt=""></td>
                  </tr>
                  <tr v-if="personal.nid_photo === null">
                    <td class="font-semibold">NID Front</td>
                    <td><img @click="popupActive5=true" class="nidImg" :src="personal.nid_front" alt=""></td>
                  </tr>
                  <tr v-if="personal.nid_photo === null">
                    <td class="font-semibold">NID Back</td>
                    <td><img @click="popupActive6=true" class="nidImg" :src="personal.nid_back" alt=""></td>
                  </tr>
                </table>
              </div>
              <!-- /Information - Col 2 -->
            </div>
            <div class="vx-row">
              <div v-if="purchaseApp.status !== 5 && purchaseApp.status !== 7" class="vx-col w-full text-right">
                <vs-checkbox
                  name="appPersonalV"
                  v-model="appPersonalV"
                  class="mt-6 float-right"
                ></vs-checkbox>
              </div>
            </div>
          </vx-card>
          <vx-card title="Applicant Contact Information">
            <div class="vx-col flex-1" id="account-info-col-1">
              <table class="table-auto">
                <tr>
                  <td class="font-semibold">Mobile</td>
                  <td>{{ applicant.phone }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Other Phone</td>
                  <td>{{ contact.other_phone || '' }}</td>
                </tr>
                <tr>
                  <td class="font-semibold">Email</td>
                  <td><span v-if="applicant.email !==null || applicant.email !==''">{{ applicant.email }}</span></td>
                </tr>
              </table>
            </div>
            <br/>
            <div class="vx-row">
              <div class="vx-col lg:w-1/2 w-full">
                <vx-card title="Present Address" class="mb-base">
                  <table v-if="presentAddress !== null" class="table-auto">
                    <tr>
                      <td class="font-semibold">Division</td>
                      <td>{{ presentAddress.division }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">District</td>
                      <td>{{ presentAddress.district }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Thana</td>
                      <td>{{ presentAddress.thana }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Apt#/ House#/ Road#/ Village#</td>
                      <td>{{ presentAddress.address }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Nearby Famous Landmark</td>
                      <td>{{ presentAddress.near_landmark }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Postal code</td>
                      <td>{{ presentAddress.postal_code }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Household Type</td>
                      <td>{{ presentAddress.house_hold_type == "tOwnResident"?"Own Resident": "Rented" }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Living in this address</td>
                      <td >{{ (presentAddress.living_in_this_address|| "").split(',')[0] }} year and {{ (presentAddress.living_in_this_address|| "").split(',')[1] }} month</td>
                    </tr>
                  </table>
                </vx-card>
              </div>

              <div class="vx-col lg:w-1/2 w-full">
                <vx-card title="Permanent Address" class="mb-base">
<!--                  {{parmanentAddress.address_frm_nid}}-->
                  <table class="table-auto">
                    <tr>
                      <td class="font-semibold">Division</td>
                      <td>{{ parmanentAddress.pdivision }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">District</td>
                      <td>{{ parmanentAddress.pdistrict }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Thana</td>
                      <td>{{ parmanentAddress.pthana }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Apt#/ House#/ Road#/ Village#</td>
                      <td>{{ parmanentAddress.paddress }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Nearby Famous Landmark</td>
                      <td>{{ parmanentAddress.pnear_landmark }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Postal code</td>
                      <td>{{ parmanentAddress.ppostal_code }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Household Type</td>
                      <td>{{ parmanentAddress.phouse_hold_type === "pOwnResident" ?"Own Resident":'Rented' }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Living in this address</td>
                      <td v-if="parmanentAddress.pliving_in_this_address !==null">{{ (parmanentAddress.pliving_in_this_address|| "").split(',')[0] }} year and {{ (parmanentAddress.pliving_in_this_address|| "").split(',')[1] }} month</td>
                    </tr>
                  </table>
                </vx-card>
              </div>
            </div>
            <div class="vx-row">
              <div v-if="purchaseApp.status !== 5 && purchaseApp.status !== 7" class="vx-col w-full text-right">
                <vs-checkbox
                  name="appContactV"
                  v-model="appContactV"
                  class="mt-6 float-right"
                ></vs-checkbox>
              </div>
            </div>
          </vx-card>
          <br/>
          <!--      Occupation and dependant-->
          <div class="vx-row">
            <div v-if="occupation !== null" class="vx-col lg:w-1/2 w-full">
              <vx-card title="Occupation Information" class="mb-base">
                <table class="table-auto">
                  <tr>
                    <td class="font-semibold">Occupation Type</td>
                    <td>{{ occupation.occupation_type }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Organization Type</td>
                    <td>{{ occupation.occupation }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Monthly Income In BDT</td>
                    <td>{{ occupation.monthly_income }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Name of the Office/Business</td>
                    <td>{{ occupation.name_of_Office_or_business }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Designation</td>
                    <td>{{ occupation.designation }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Job length</td>
                    <td>{{ userJobLYear }} year and {{userJobLMonth}} month</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Division</td>
                    <td>{{ occuAddress.division }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">District</td>
                    <td>{{ occuAddress.district }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Thana</td>
                    <td>{{ occuAddress.thana }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Office Area</td>
                    <td>{{ occuAddress.office_area }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Apt#/ House#/ Road#/ Village#</td>
                    <td>{{ occuAddress.address }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">Postal code</td>
                    <td>{{ occuAddress.postal_code }}</td>
                  </tr>
                </table>
                <div class="vx-row">
                  <div v-if="purchaseApp.status !== 5 && purchaseApp.status !== 7" class="vx-col w-full text-right">
                    <vs-checkbox
                      name="appOccupationV"
                      v-model="appOccupationV"
                      class="mt-6 float-right"
                    ></vs-checkbox>
                  </div>
                </div>
              </vx-card>
            </div>

            <div class="vx-col lg:w-1/2 w-full">
              <vx-card
                v-if="dependent !== null"
                title="Dependent Information"
                class="mb-base"
              >
                <table class="table-auto">
                  <tr>
                    <td class="font-semibold">
                      No. of Children living with you
                    </td>
                    <td>&nbsp; &nbsp;{{ dependent.number_of_child }}</td>
                  </tr>
                  <tr>
                    <td class="font-semibold">
                      No. of dependent living with you
                    </td>
                    <td>&nbsp; &nbsp;{{ dependent.number_of_dependent }}</td>
                  </tr>
                  <br/>
                </table>
                <table  stripe  v-if="depandantDetails !== null"  style="max-height: 235px; overflow: scroll; width: 100%">
                  <thead>
                  <tr>
                    <th>Relation</th>
                    <th>Name</th>
                    <th>Age</th>
                  </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(dependent, indextr) in depandantDetails" :key="indextr"  >
                      <td>
                        {{ dependent.relation }}
                      </td>
                      <td>
                        {{ dependent.name }}
                      </td>
                      <td>
                        {{ dependent.age }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="vx-row">
                  <div v-if="purchaseApp.status !== 5 && purchaseApp.status !== 7" class="vx-col w-full text-right">
                    <vs-checkbox
                      name="appDependentV"
                      v-model="appDependentV"
                      class="mt-6 float-right"
                    ></vs-checkbox>
                  </div>
                </div>

              </vx-card>
            </div>
          </div>

      </div>
      <div class="w-full">
        <h4 class="custom-title">Guarantor Information -{{guarantor.name}}</h4>
        <br/>
              <vx-card title="Personal Information" class="mb-base">
                <!-- Avatar -->
                <div class="vx-row" v-if="guarantor.ekyc !== null">
                  <!-- Avatar Col -->
                  <div class="vx-col" id="avatar-col">
                    <div v-if="guarantor.ekyc.parsonal.photo" class="img-container mb-4">
                                <img :src="guarantor.ekyc.parsonal.photo" class="rounded w-full" />
                    </div>
                  </div>
                  <!-- Information - Col 1 -->
                  <div class="vx-col flex-1" id="account-info-col-1">
                    <table class="table-auto" v-if="guarantor.ekyc.parsonal !== null">
                      <tr>
                        <td class="font-semibold">First Name</td>
                        <td>{{ guarantor.ekyc.parsonal.name }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Last Name</td>
                        <td>{{ guarantor.ekyc.parsonal.last_name }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Father’s Name</td>
                        <td>{{ guarantor.ekyc.parsonal.father_name }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Mother’s Name</td>
                        <td>{{ guarantor.ekyc.parsonal.mother_name }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Spouse Name</td>
                        <td>{{ guarantor.ekyc.parsonal.spouse_name }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Age</td>
                        <td>{{ guarantor.ekyc.parsonal.age }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Marital Status</td>
                        <td>{{ guarantor.ekyc.parsonal.marital_status }}</td>
                      </tr>
                    </table>
                  </div>
                  <!-- /Information - Col 1 -->

                  <!-- Information - Col 2 -->
                  <div
                    v-if="guarantor.ekyc.parsonal !== null"
                    class="vx-col flex-1"
                    id="account-info-col-2"
                  >
                    <table class="table-auto">
                      <tr>
                        <td class="font-semibold">Gender</td>
                        <td>{{ guarantor.ekyc.parsonal.gender }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Head of Household</td>
                        <td>{{ guarantor.ekyc.parsonal.head_of_household === true?'Yes':'No' }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Education Level</td>
                        <td>{{ guarantor.ekyc.parsonal.education_level }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">NID No</td>
                        <td>{{ guarantor.ekyc.parsonal.nid }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Relationship</td>
                        <td>{{ guarantor.ekyc.parsonal.relationship }}</td>
                      </tr>
                      <tr v-if="guarantor.ekyc.parsonal.nid_photo !== null">
                        <td class="font-semibold">NID Front</td>
                        <td><img @click="popupActive13=true" class="nidImg" :src="guarantor.ekyc.parsonal.nid_photo" alt=""></td>
                      </tr>
                      <tr v-if="guarantor.ekyc.parsonal.nid_photo === null">
                        <td class="font-semibold">NID Front</td>
                        <td><img @click="popupActive7=true" class="nidImg" :src="guarantor.ekyc.parsonal.nid_front" alt=""></td>
                      </tr>
                      <tr v-if="guarantor.ekyc.parsonal.nid_photo === null">
                        <td class="font-semibold">NID Back</td>
                        <td><img @click="popupActive8=true" class="nidImg" :src="guarantor.ekyc.parsonal.nid_back" alt=""></td>
                      </tr>
                      <template>
                        <div class="demo-alignment">
                          <vs-popup class="holamundo" title="NID Front Image preview" :active.sync="popupActive13">
                            <img class="nidImgPrev"  :src="guarantor.ekyc.parsonal.nid_photo" alt="">
                          </vs-popup>
                        </div>
                      </template>
                      <template>
                        <div class="demo-alignment">
                          <vs-popup class="holamundo" title="NID Front Image preview" :active.sync="popupActive7">
                            <img class="nidImgPrev"  :src="guarantor.ekyc.parsonal.nid_front" alt="">
                          </vs-popup>
                        </div>
                      </template>
                      <template>
                        <div class="demo-alignment">
                          <vs-popup class="holamundo" title="NID Back Image preview" :active.sync="popupActive8">
                            <img class="nidImgPrev" :src="guarantor.ekyc.parsonal.nid_back" alt="">
                          </vs-popup>
                        </div>
                      </template>

                    </table>
                  </div>
                  <!-- /Information - Col 2 -->
                </div>
                <div v-if="guarantor.parsonal !== null" class="vx-row">
                  <div v-if="purchaseApp.status !== 5 && purchaseApp.status !== 7" class="vx-col w-full text-right">
                    <vs-checkbox
                      name=""
                      v-model="gOnePerInfoV"
                      class="float-right"
                    ></vs-checkbox>
<!--                    <vs-button
                      color="success"
                      class="mr-3 mb-2 float-right"
                      size="small"
                      @click="
                        updatePersonalInfo(
                          guarantor.id,
                          guarantor.ekyc.id,
                          purchaseApp.id
                        )
                      "
                    >Edit Personal Information
                    </vs-button>-->
                  </div>
                </div>
              </vx-card>
              <vx-card
                v-if="guarantor.ekyc !== null"
                title="Contact Information"
              >
                <div
                  v-if="guarantor.ekyc.contact !== null"
                  class="vx-col flex-1"
                  id="account-info-col-1"
                >
                  <table class="table-auto">
                    <tr>
                      <td class="font-semibold">Mobile</td>
                      <td>{{ guarantor.phone }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Other Phone</td>
                      <td>{{ guarantor.ekyc.contact.other_phone || '' }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Email</td>
                      <td><span v-if="guarantor.ekyc.contact.email !==null || guarantor.ekyc.contact.email !==''">{{ guarantor.ekyc.contact.email }}</span></td>
                    </tr>
                  </table>
                </div>
                <br/>
                <div v-if="guarantor.ekyc.contact !== null" class="vx-row">
                  <div class="vx-col lg:w-1/2 w-full">
                    <vx-card title="Present Address" class="mb-base">
                      <table class="table-auto">
                        <tr>
                          <td class="font-semibold">Division</td>
                          <td>
                            {{ guarantor.ekyc.contact.presentAddress.division }}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">District</td>
                          <td>
                            {{ guarantor.ekyc.contact.presentAddress.district }}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Thana</td>
                          <td>
                            {{ guarantor.ekyc.contact.presentAddress.thana }}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">
                            Apt#/ House#/ Road#/ Village#
                          </td>
                          <td>
                            {{ guarantor.ekyc.contact.presentAddress.address }}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Nearby Famous Landmark</td>
                          <td>
                            {{ guarantor.ekyc.contact.presentAddress.near_landmark}}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Postal code</td>
                          <td>
                            {{guarantor.ekyc.contact.presentAddress.postal_code}}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Household Type</td>
                          <td>
                            {{guarantor.ekyc.contact.presentAddress.house_hold_type == "tOwnResident"? "Own Resident" : "Rented"}}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Living in this address</td>
                          <td>
                            {{ (guarantor.ekyc.contact.presentAddress.living_in_this_address || "").split(',')[0] }} year and {{ (guarantor.ekyc.contact.presentAddress.living_in_this_address  || "").split(',')[1] }} month
                          </td>
                        </tr>
                      </table>
                    </vx-card>
                  </div>

                  <div class="vx-col lg:w-1/2 w-full">
                    <vx-card title="Permanent Address" class="mb-base">
                      {{guarantor.ekyc.contact.permanentAddress.address_frm_nid}}
<!--                      <table class="table-auto">
                        <tr>
                          <td class="font-semibold">Division</td>
                          <td>
                            {{ guarantor.ekyc.contact.permanentAddress.pdivision}}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">District</td>
                          <td>
                            {{guarantor.ekyc.contact.permanentAddress.pdistrict}}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Thana</td>
                          <td>
                            {{ guarantor.ekyc.contact.permanentAddress.pthana }}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">
                            Apt#/ House#/ Road#/ Village#
                          </td>
                          <td>
                            {{guarantor.ekyc.contact.permanentAddress.paddress}}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Nearby Famous Landmark</td>
                          <td>
                            {{guarantor.ekyc.contact.permanentAddress.pnear_landmark}}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Postal code</td>
                          <td>
                            {{guarantor.ekyc.contact.permanentAddress.ppostal_code}}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Household Type</td>
                          <td>
                            {{guarantor.ekyc.contact.permanentAddress.phouse_hold_type == "pOwnResident"? "Own Resident" : "Rented"}}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Living in this address</td>
                          <td>
                            {{ (guarantor.ekyc.contact.permanentAddress.pliving_in_this_address || "").split(',')[0] }} year and {{ (guarantor.ekyc.contact.permanentAddress.pliving_in_this_address || "").split(',')[1] }} month
                          </td>
                        </tr>
                      </table>-->
                    </vx-card>
                  </div>
                </div>
                <div v-if="purchaseApp.status !== 5 && purchaseApp.status !== 7" class="vx-row">
                  <div class="vx-col w-full text-right">
                    <vs-checkbox  name="gOneContactInfoV" v-model="gOneContactInfoV" class="float-right"></vs-checkbox>
                    <vs-button color="success" class="mr-3 mb-2 float-right" size="small" @click="updateContactInfo( guarantor.id, guarantor.ekyc.id, purchaseApp.id )">Edit Contact Information
                    </vs-button>
                  </div>
                </div>
              </vx-card>
              <br/>
              <!--      Occupation and dependant-->
              <div class="vx-row">
                <div
                  v-if="guarantor.ekyc !== null"
                  class="vx-col lg:w-1/2 w-full"
                >
                  <vx-card
                    title="Occupation Information"
                    class="mb-base"
                  >
                    <table class="table-auto" v-if="guarantor.ekyc.occupation !== null">
                      <tr>
                        <td class="font-semibold">Occupation Type</td>
                        <td>{{ guarantor.ekyc.occupation.occupation_type }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Organization Type</td>
                        <td>{{ guarantor.ekyc.occupation.occupation }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Monthly Income In BDT</td>
                        <td>{{ guarantor.ekyc.occupation.monthly_income }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">
                          Name of the Office/Business
                        </td>
                        <td>
                          {{guarantor.ekyc.occupation.name_of_Office_or_business}}
                        </td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Designation</td>
                        <td>{{ guarantor.ekyc.occupation.designation }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Job length</td>
                        <td v-if="guarantor.ekyc.occupation !== null"> {{ (guarantor.ekyc.occupation.job_length || "").split(',')[0] }} year and {{(guarantor.ekyc.occupation.job_length || "").split(',')[1] }} month
                        </td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Division</td>
                        <td>
                          {{guarantor.ekyc.occupation.occupationAddress.division}}
                        </td>
                      </tr>
                      <tr>
                        <td class="font-semibold">District</td>
                        <td>
                          {{guarantor.ekyc.occupation.occupationAddress.district}}
                        </td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Thana</td>
                        <td>
                          {{guarantor.ekyc.occupation.occupationAddress.thana}}
                        </td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Office Area</td>
                        <td>
                          {{guarantor.ekyc.occupation.occupationAddress.office_area}}
                        </td>
                      </tr>
                      <tr>
                        <td class="font-semibold">
                          Apt#/ House#/ Road#/ Village#
                        </td>
                        <td>
                          {{guarantor.ekyc.occupation.occupationAddress.address}}
                        </td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Postal code</td>
                        <td>
                          {{guarantor.ekyc.occupation.occupationAddress.postal_code}}
                        </td>
                      </tr>
                    </table>
                    <div v-if="purchaseApp.status !== 5 && purchaseApp.status !== 7" class="vx-row">
                      <div class="vx-col w-full text-right">
                        <vs-checkbox
                          name="gOneOccuInfoV"
                          v-model="gOneOccuInfoV"
                          class="float-right"
                        ></vs-checkbox>
                        <vs-button
                          color="success"
                          class="mr-3 mb-2 float-right"
                          size="small"
                          @click="
                            updateOccupationInfo(
                              guarantor.id,
                              guarantor.ekyc.id,
                              purchaseApp.id
                            )
                          "
                        >Edit Occupation Information
                        </vs-button>
                      </div>
                    </div>
                  </vx-card>
                </div>

                <div
                  v-if="guarantor.ekyc !== null"
                  class="vx-col lg:w-1/2 w-full"
                >
                  <vx-card
                    title="Dependent Information"
                    class="mb-base"
                  >
                    <table class="table-auto" v-if="guarantor.ekyc.dependent !== null">
                      <tr>
                        <td class="font-semibold">
                          No. of Children living with you
                        </td>
                        <td>{{ guarantor.ekyc.dependent.number_of_child }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">
                          No. of dependent living with you
                        </td>
                        <td>
                          {{ guarantor.ekyc.dependent.number_of_dependent }}
                        </td>
                      </tr>
                      <br/>
                    </table>
                    <div v-if="guarantor.ekyc.dependent !== null" class="">
                      <table class="table-auto"  stripe  v-if="guarantor.ekyc.dependent.depandantDetails !== null"   style="max-height: 235px; overflow: scroll; width: 100%"   >
                        <thead>
                        <tr>
                          <th>Relation</th>
                          <th>Name</th>
                          <th>Age</th>
                        </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(dependent, indextr) in guarantor.ekyc
                            .dependent.depandantDetails"
                            :key="indextr"
                          >
                            <td>
                              {{ dependent.relation }}
                            </td>
                            <td>
                              {{ dependent.name }}
                            </td>
                            <td>
                              {{ dependent.age }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <br/>
                    <div v-if="purchaseApp.status !== 5 && purchaseApp.status !== 7" class="vx-col w-full text-right">
                      <vs-checkbox
                        name="gOneDependentInfoV"
                        v-model="gOneDependentInfoV"
                        class="float-right"
                      ></vs-checkbox>
                      <vs-button
                        color="success"
                        class="mr-3 mb-2 float-right"
                        size="small"
                        @click="
                          updateDependentInfo(
                            guarantor.id,
                            guarantor.ekyc.id,
                            purchaseApp.id
                          )
                        "
                      >Edit Dependent Information
                      </vs-button>
                    </div>
                    <br/>
                  </vx-card>
                </div>
              </div>
              <!-- Showroom and Product  -->

              <br/>

            <!--        Guarantor 2-->
        <h4 class="custom-title">Guarantor Information -{{guarantorSec.name}} </h4>
        <br/>


              <vx-card title="Personal Information" class="mb-base">
                <!-- Avatar -->
                <div class="vx-row" v-if="guarantorSec.ekyc !== null">
                  <!-- Avatar Col -->
                  <div class="vx-col" id="avatar-col">
                    <div class="img-container mb-4">
                                <img :src="guarantorSec.ekyc.parsonal.photo" class="rounded w-full" />
                    </div>
                  </div>
                  <!-- Information - Col 1 -->
                  <div class="vx-col flex-1" id="account-info-col-1">
                    <table class="table-auto" v-if="guarantorSec.ekyc.parsonal !== null">
                      <tr>
                        <td class="font-semibold">First Name</td>
                        <td>{{ guarantorSec.ekyc.parsonal.name }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Last Name</td>
                        <td>{{ guarantorSec.ekyc.parsonal.last_name }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Father’s Name</td>
                        <td>{{ guarantorSec.ekyc.parsonal.father_name }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Mother’s Name</td>
                        <td>{{ guarantorSec.ekyc.parsonal.mother_name }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Spouse Name</td>
                        <td>{{ guarantorSec.ekyc.parsonal.spouse_name }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Age</td>
                        <td>{{ guarantorSec.ekyc.parsonal.age }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Marital Status</td>
                        <td>{{ guarantorSec.ekyc.parsonal.marital_status }}</td>
                      </tr>
                    </table>
                  </div>
                  <!-- /Information - Col 1 -->

                  <!-- Information - Col 2 -->
                  <div
                    v-if="guarantorSec.ekyc.parsonal !== null"
                    class="vx-col flex-1"
                    id="account-info-col-2"
                  >
                    <table class="table-auto">
                      <tr>
                        <td class="font-semibold">Gender</td>
                        <td>{{ guarantorSec.ekyc.parsonal.gender }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Head of Household</td>
                        <td>{{ guarantorSec.ekyc.parsonal.head_of_household === true?'Yes':'No' }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Education Level</td>
                        <td>{{ guarantorSec.ekyc.parsonal.education_level }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">NID No</td>
                        <td>{{ guarantorSec.ekyc.parsonal.nid }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Relationship</td>
                        <td>{{ guarantorSec.ekyc.parsonal.relationship }}</td>
                      </tr>
                      <tr v-if="guarantorSec.ekyc.parsonal.nid_photo !== null">
                        <td class="font-semibold">Photo from Nid</td>
                        <td><img @click="popupActive12=true" class="nidImg" :src="guarantorSec.ekyc.parsonal.nid_photo" alt=""></td>
                      </tr>
                      <tr v-if="guarantorSec.ekyc.parsonal.nid_photo === null">
                        <td class="font-semibold">NID Front</td>
                        <td><img @click="popupActive9=true" class="nidImg" :src="guarantorSec.ekyc.parsonal.nid_front" alt=""></td>
                      </tr>
                      <tr v-if="guarantorSec.ekyc.parsonal.nid_photo === null">
                        <td class="font-semibold">NID Back</td>
                        <td><img @click="popupActive10=true" class="nidImg" :src="guarantorSec.ekyc.parsonal.nid_back" alt=""></td>
                      </tr>
                      <template>
                        <div class="demo-alignment">
                          <vs-popup class="holamundo" title="NID Front Image preview" :active.sync="popupActive12">
                            <img class="nidImgPrev"  :src="guarantorSec.ekyc.parsonal.nid_photo" alt="">
                          </vs-popup>
                        </div>
                      </template>
                      <template>
                        <div class="demo-alignment">
                          <vs-popup class="holamundo" title="NID Front Image preview" :active.sync="popupActive9">
                            <img class="nidImgPrev"  :src="guarantorSec.ekyc.parsonal.nid_front" alt="">
                          </vs-popup>
                        </div>
                      </template>
                      <template>
                        <div class="demo-alignment">
                          <vs-popup class="holamundo" title="NID Back Image preview" :active.sync="popupActive10">
                            <img class="nidImgPrev" :src="guarantorSec.ekyc.parsonal.nid_back" alt="">
                          </vs-popup>
                        </div>
                      </template>
                    </table>
                  </div>
                  <!-- /Information - Col 2 -->
                </div>
                <div v-if="guarantorSec.parsonal !== null" class="vx-row">
                  <div v-if="purchaseApp.status !== 5 && purchaseApp.status !== 7" class="vx-col w-full text-right">
                    <vs-checkbox
                      name="gTwoPerInfoV"
                      v-model="gTwoPerInfoV"
                      class="float-right"
                    ></vs-checkbox>
<!--                    <vs-button
                      color="success"
                      class="mr-3 mb-2 float-right"
                      size="small"
                      @click="
                        updatePersonalInfo(
                          guarantorSec.id,
                          guarantorSec.ekyc.id,
                          guarantorSec.id
                        )
                      "
                    >Edit Personal Information
                    </vs-button>-->
                  </div>
                </div>
              </vx-card>
              <vx-card
                v-if="guarantorSec.ekyc !== null"
                title="Contact Information"
              >
                <div
                  v-if="guarantorSec.ekyc.contact !== null"
                  class="vx-col flex-1"
                  id="account-info-col-1"
                >
                  <table class="table-auto">
                    <tr>
                      <td class="font-semibold">Mobile</td>
                      <td>{{ guarantorSec.phone }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Other Phone</td>
                      <td>{{ guarantorSec.ekyc.contact.other_phone || '' }}</td>
                    </tr>
                    <tr>
                      <td class="font-semibold">Email</td>
                      <td><span v-if="guarantorSec.ekyc.contact.email !==null || guarantorSec.ekyc.contact.email !==''">{{ guarantorSec.ekyc.contact.email }}</span></td>
                    </tr>
                  </table>
                </div>
                <br/>
                <div v-if="guarantorSec.ekyc.contact !== null" class="vx-row">
                  <div class="vx-col lg:w-1/2 w-full">
                    <vx-card title="Present Address" class="mb-base">
                      <table class="table-auto">
                        <tr>
                          <td class="font-semibold">Division</td>
                          <td>
                            {{ guarantorSec.ekyc.contact.presentAddress.division }}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">District</td>
                          <td>
                            {{ guarantorSec.ekyc.contact.presentAddress.district }}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Thana</td>
                          <td>
                            {{ guarantorSec.ekyc.contact.presentAddress.thana }}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">
                            Apt#/ House#/ Road#/ Village#
                          </td>
                          <td>
                            {{ guarantorSec.ekyc.contact.presentAddress.address }}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Nearby Famous Landmark</td>
                          <td>
                            {{ guarantorSec.ekyc.contact.presentAddress.near_landmark}}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Postal code</td>
                          <td>
                            {{guarantorSec.ekyc.contact.presentAddress.postal_code}}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Household Type</td>
                          <td>
                            {{guarantorSec.ekyc.contact.presentAddress.house_hold_type == "tOwnResident"? 'Own Resident':'Rented'}}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Living in this address</td>
                          <td v-if="guarantorSec.ekyc.contact.presentAddress !== null">
                            {{ (guarantorSec.ekyc.contact.presentAddress.living_in_this_address || "").split(',')[0] }} year and {{ (guarantorSec.ekyc.contact.presentAddress.living_in_this_address|| "").split(',')[1] }} month
                          </td>
                        </tr>
                      </table>
                    </vx-card>
                  </div>

                  <div class="vx-col lg:w-1/2 w-full">
                    <vx-card title="Permanent Address" class="mb-base">
                      {{guarantorSec.ekyc.contact.permanentAddress.address_frm_nid}}
<!--                      <table class="table-auto">
                        <tr>
                          <td class="font-semibold">Division</td>
                          <td>
                            {{ guarantorSec.ekyc.contact.permanentAddress.pdivision}}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">District</td>
                          <td>
                            {{guarantorSec.ekyc.contact.permanentAddress.pdistrict}}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Thana</td>
                          <td>
                            {{ guarantorSec.ekyc.contact.permanentAddress.pthana }}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">
                            Apt#/ House#/ Road#/ Village#
                          </td>
                          <td>
                            {{guarantorSec.ekyc.contact.permanentAddress.paddress}}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Nearby Famous Landmark</td>
                          <td>
                            {{guarantorSec.ekyc.contact.permanentAddress.pnear_landmark}}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Postal code</td>
                          <td>
                            {{guarantorSec.ekyc.contact.permanentAddress.ppostal_code}}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Household Type</td>
                          <td>
                            {{guarantorSec.ekyc.contact.permanentAddress.phouse_hold_type === "pOwnResident"? "Own Resident" : "Rented"}}
                          </td>
                        </tr>
                        <tr>
                          <td class="font-semibold">Living in this address</td>
                          <td>
                            {{ (guarantorSec.ekyc.contact.permanentAddress.pliving_in_this_address || "").split(',')[0] }} year and {{ (guarantorSec.ekyc.contact.permanentAddress.pliving_in_this_address || "").split(',')[1] }} month
                          </td>
                        </tr>
                      </table>-->
                    </vx-card>
                  </div>
                </div>
                <div v-if="purchaseApp.status !== 5 && purchaseApp.status !== 7" class="vx-row">
                  <div class="vx-col w-full text-right">
                    <vs-checkbox
                      :name="gTwoContactInfoV"
                      v-model="gTwoContactInfoV"
                      class="float-right"
                    ></vs-checkbox>
                    <vs-button
                      color="success"
                      class="mr-3 mb-2 float-right"
                      size="small"
                      @click="
                        updateContactInfo(
                          guarantorSec.id,
                          guarantorSec.ekyc.id,
                          purchaseApp.id
                        )
                      "
                    >Edit Contact Information
                    </vs-button>
                  </div>
                </div>
              </vx-card>
              <br/>
              <!--      Occupation and dependant-->
              <div class="vx-row">
                <div
                  v-if="guarantorSec.ekyc !== null"
                  class="vx-col lg:w-1/2 w-full"
                >
                  <vx-card
                    title="Occupation Information"
                    class="mb-base"
                  >
                    <table class="table-auto" v-if="guarantorSec.ekyc.occupation !== null">
                      <tr>
                        <td class="font-semibold">Occupation Type</td>
                        <td>{{ guarantorSec.ekyc.occupation.occupation_type }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Occupation</td>
                        <td>{{ guarantorSec.ekyc.occupation.occupation }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Monthly Income In BDT</td>
                        <td>{{ guarantorSec.ekyc.occupation.monthly_income }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">
                          Name of the Office/Business
                        </td>
                        <td>
                          {{guarantorSec.ekyc.occupation.name_of_Office_or_business}}
                        </td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Designation</td>
                        <td>{{ guarantorSec.ekyc.occupation.designation }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Job length</td>
                        <td> {{ (guarantorSec.ekyc.occupation.job_length || "").split(',')[0] }} year and {{(guarantorSec.ekyc.occupation.job_length || "").split(',')[1] }} month
                        </td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Division</td>
                        <td>
                          {{guarantorSec.ekyc.occupation.occupationAddress.division}}
                        </td>
                      </tr>
                      <tr>
                        <td class="font-semibold">District</td>
                        <td>
                          {{guarantorSec.ekyc.occupation.occupationAddress.district}}
                        </td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Thana</td>
                        <td>
                          {{guarantorSec.ekyc.occupation.occupationAddress.thana}}
                        </td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Office Area</td>
                        <td>
                          {{guarantorSec.ekyc.occupation.occupationAddress.office_area}}
                        </td>
                      </tr>
                      <tr>
                        <td class="font-semibold">
                          Apt#/ House#/ Road#/ Village#
                        </td>
                        <td>
                          {{guarantorSec.ekyc.occupation.occupationAddress.address}}
                        </td>
                      </tr>
                      <tr>
                        <td class="font-semibold">Postal code</td>
                        <td>
                          {{guarantorSec.ekyc.occupation.occupationAddress.postal_code}}
                        </td>
                      </tr>
                    </table>
                    <div v-if="purchaseApp.status !== 5 && purchaseApp.status !== 7" class="vx-row">
                      <div class="vx-col w-full text-right">
                        <vs-checkbox
                          :name="gTwoOccuInfoV"
                          v-model="gTwoOccuInfoV"
                          class="float-right"
                        ></vs-checkbox>
                        <vs-button
                          color="success"
                          class="mr-3 mb-2 float-right"
                          size="small"
                          @click="
                            updateOccupationInfo(
                              guarantorSec.id,
                              guarantorSec.ekyc.id,
                              purchaseApp.id
                            )
                          "
                        >Edit Occupation Information
                        </vs-button>
                      </div>
                    </div>
                  </vx-card>
                </div>

                <div
                  v-if="guarantorSec.ekyc !== null"
                  class="vx-col lg:w-1/2 w-full"
                >
                  <vx-card
                    title="Dependent Information"
                    class="mb-base"
                  >
                    <table class="table-auto" v-if="guarantorSec.ekyc.dependent !== null">
                      <tr>
                        <td class="font-semibold">
                          No. of Children living with you
                        </td>
                        <td>{{ guarantorSec.ekyc.dependent.number_of_child }}</td>
                      </tr>
                      <tr>
                        <td class="font-semibold">
                          No. of dependent living with you
                        </td>
                        <td>
                          {{ guarantorSec.ekyc.dependent.number_of_dependent }}
                        </td>
                      </tr>
                      <br/>
                    </table>
                    <div v-if="guarantorSec.ekyc.dependent !== null" class="">
                      <table class="table-auto"  stripe  v-if="guarantorSec.ekyc.dependent.depandantDetails !== null"   style="max-height: 235px; overflow: scroll; width: 100%"   >
                        <thead>
                        <tr>
                          <th>Relation</th>
                          <th>Name</th>
                          <th>Age</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr
                          v-for="(dependent, indextr) in guarantorSec.ekyc.dependent.depandantDetails" :key="indextr">
                          <td>
                            {{ dependent.relation }}
                          </td>
                          <td>
                            {{ dependent.name }}
                          </td>
                          <td>
                            {{ dependent.age }}
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <br/>
                    <div class="vx-row" v-if="purchaseApp.status !== 5 && purchaseApp.status !== 7">
                      <div  class="vx-col w-full text-right">
                        <vs-checkbox
                          :name="gTwoDependentInfoV"
                          v-model="gTwoDependentInfoV"
                          class="float-right"
                        ></vs-checkbox>
                        <vs-button
                          color="success"
                          class="mr-3 mb-2 float-right"
                          size="small"
                          @click="
                          updateDependentInfo(
                            guarantorSec.id,
                            guarantorSec.ekyc.id,
                            purchaseApp.id
                          )
                        "
                        >Edit Dependent Information
                        </vs-button>
                      </div>
                    </div>
                  </vx-card>
                </div>
              </div>
              <!-- Showroom and Product  -->
      </div>
      <br/>
    <template>
      <div class="demo-alignment">
        <vs-popup classContent="popup-example" title="Article No" :active.sync="popupActive2">
          <vs-input class="inputx mb-3" placeholder="Article No" v-model="article"/>
          <!--<vs-input class="inputx mb-3" placeholder="Invoice No" v-model="invoice"/>-->
          <vs-button @click="findArticle(article)" color="rgb(0 121 193)" type="filled">Search</vs-button>
          <vx-card v-if="articleDetail" title="Article Information">
            <table>
              <tbody>
              <tr>
                <td>Article No</td>
                <td>{{articleDetail.article}}</td>
              </tr>
              <tr>
                <td>Article Description</td>
                <td>{{articleDetail.article_description}}</td>
              </tr>
              <tr>
                <td>Profit Center</td>
                <td>{{articleDetail.profit_center}}</td>
              </tr>
              <tr>
                <td>Profit Center Description</td>
                <td>{{articleDetail.profit_center_description}}</td>
              </tr>
              <tr>
                <td>Mdse cat</td>
                <td>{{articleDetail.mdse_cat}}</td>
              </tr>
              <tr>
                <td>Merchandise Category</td>
                <td>{{articleDetail.merchandise_category}}</td>
              </tr>
              <tr>
                <td>Hire Price</td>
                <td>{{articleDetail.hire_price}}</td>
              </tr>
              <tr>
                <td>Down Payment</td>
                <td>{{articleDetail.down_payment}}</td>
              <tr>
                <td>Monthly Installment</td>
                <td>{{articleDetail.monthly_inst}}</td>
              </tr>
              <tr>
                <td>Pricing Date</td>
                <td>{{articleDetail.pricing_date}}</td>
              </tr>
              </tbody>
            </table>
            <br>
            <vs-input class="inputx mb-3" placeholder="Serial No" v-model="articleSerialNo"/>
            <!--<vs-input class="inputx mb-3" placeholder="Invoice No" v-model="invoiceNumber"/>-->
            <div class="vx-row w-full text-right">
              <vs-button :disabled="isDisabled" @click="finalAcceptAppl" color="success" type="filled">Confirm Accept</vs-button>
            </div>
          </vx-card>

        </vs-popup>
      </div>
    </template>
    <vx-card v-if="purchaseApp.status !== 5 && purchaseApp.status !== 7">
      <div class="vx-row" v-if="purchaseApp.status !== 5 && purchaseApp.status !== 7">
        <div class="vx-col sm:w-1/1 w-full mb-2">
          <template>
            <div>
              <vs-textarea v-model="note" placeholder="Comment"/>
              <span v-if="isHalt">Note Field is required.</span>
            </div>
          </template>
        </div>
      </div>

      <div class="vx-row">
        <div v-if="purchaseApp.status !== 5 && purchaseApp.status !== 7" class="vx-col w-full text-right">
          <vs-button v-if="purchaseApp.user.status" color="warning" class="mr-3 mb-2 float-right" @click="rejectApplication">Reject</vs-button>
          <vs-button v-if="purchaseApp.user.status" :disabled="note === ''" color="danger" class="mr-3 mb-2 float-right" @click="haltApplication">Halt</vs-button>
          <vs-button v-if="purchaseApp.user.status" color="success" class="mr-3 mb-2 float-right" @click="saveApplication">Save</vs-button>

          <!--<vs-button
            color="success"
            class="mr-3 mb-2 float-right"
            :disabled="!validateForm"
          >Accept
          </vs-button>-->
          <vs-button v-if="purchaseApp.user.status" color="success" class="mr-3 mb-2 float-right" @click="popupActive2=true" :disabled="!validateForm">
            Accept
          </vs-button>
          <vs-button v-if="purchaseApp.user.status" color="success" class="mr-3 mb-2 float-right" @click="popupActive2=true" :disabled="!validateForm">
            Reprocess
          </vs-button>
        </div>
      </div>
    </vx-card>
    <template>
      <div class="demo-alignment">
        <vs-popup class="holamundo" title="Photo from Nid" :active.sync="popupActive11">
          <img class="nidImgPrev"  :src="personal.nid_photo" alt="">
        </vs-popup>
      </div>
    </template>
    <template>
      <div class="demo-alignment">
        <vs-popup class="holamundo" title="NID Front Image preview" :active.sync="popupActive5">
          <img class="nidImgPrev"  :src="personal.nid_front" alt="">
        </vs-popup>
      </div>
    </template>
    <template>
      <div class="demo-alignment">
        <vs-popup class="holamundo" title="NID Back Image preview" :active.sync="popupActive6">
          <img class="nidImgPrev" :src="personal.nid_back" alt="">
        </vs-popup>
      </div>
    </template>
  </div>

</template>
<script>
  import GuarantorOne from './pages/ApplicationList.vue'
  import productMaster from '../graphql/productMaster.gql'
  import saveApplication from '../graphql/saveApplications.gql'
  import haltApplication from '../graphql/haltApplications.gql'
  import acceptReject from '../graphql/ApplicationAcceptReject.gql'
  import rejectAppplication from '../graphql/RejectApplication.gql'
  import gql from 'graphql-tag'

  export default {
    data () {
      return {
        purchase: {},
        note: '',
        isHalt: false,
        articleSerialNo: '',
        applications: '',
        purchaseApp: '',
        product: '',
        user: '',
        applicant: '',
        userJobLYear: '',
        userJobLMonth: '',
        guarantorList: [{
          gOnePersonalCheck: false,
          gOneContactCheck: false,
          gOneOccupationCheck: false,
          gOneDependentCheck: false
        }],
        guarantor: {
          ekyc: {
            parsonal: {
              verifyed:''
            },
            contact: {
              presentAddress: {},
              permanentAddress: {},
              verifyed:''
            },
            occupation: {
              occupationAddress: {},
              verifyed:''
            },
            dependent:{
              number_of_child:0
            }
          }
        },
        guarantorSec: {
          ekyc: {
            parsonal: {
              verifyed:''
            },
            contact: {
              presentAddress: {},
              permanentAddress: {},
              verifyed:''
            },
            occupation: {
              occupationAddress: {},
              verifyed:''
            },
            dependent:{
              number_of_child:0
            }
          }
        },
        personal: {
          applicantPersonalCheck: false,
          applicantContactCheck: false,
          applicantOccupationCheck: false,
          applicantDepandentCheck: false
        },
        contact: '',
        occupation: '',
        occuAddress: '',
        dependent: '',
        presentAddress: '',
        parmanentAddress: '',
        depandantDetails: [],

        ekycId: '',
        value1: '',
        value2: '',
        popupActive2: false,
        popupActive3: false,
        article: '',
        invoice: '',
        articleDetail: '',
        verifyList: [],
        appPersonalV: false,
        appContactV: false,
        appOccupationV:  false,
        appDependentV:  false,
        gOnePerInfoV:  false,
        gOneContactInfoV:  false,
        gOneOccuInfoV:  false,
        gOneDependentInfoV:  false,
        gTwoPerInfoV:  false,
        gTwoContactInfoV:  false,
        gTwoOccuInfoV:  false,
        gTwoDependentInfoV:  false,
        popupActive11: false,
        popupActive12: false,
        popupActive13: false,
        popupActive5: false,
        popupActive6: false,
        popupActive7: false,
        popupActive8: false,
        popupActive9: false,
        popupActive10: false,
      }
    },
    apollo: {
      purchase: {
        query: gql`
        query purchase($id: ID) {
          purchase(id: $id) {
            id
            used_location
            location
            brand
            price_range
            status
            comment
            guarantors {
              id
              name
              phone
              email
              relationship
              status
              ekyc {
                id
                phone
                nid
                email
                status
                parsonal {
                  id
                  name
                  last_name
                  father_name
                  mother_name
                  spouse_name
                  age
                  marital_status
                  gender
                  head_of_household
                  education_level
                  nid
                  nid_front
                  nid_back
                  photo
                  verifyed
                  nid_photo
                }
                contact {
                  id
                  mobile
                  other_phone
                  email
                  verifyed
                  presentAddress {
                    id
                    division
                    district
                    thana
                    address
                    near_landmark
                    postal_code
                    house_hold_type
                    living_in_this_address
                  }
                  permanentAddress {
                    id
                    pdivision
                    pdistrict
                    pthana
                    paddress
                    pnear_landmark
                    ppostal_code
                    phouse_hold_type
                    pliving_in_this_address
                    address_frm_nid
                  }
                }
                occupation {
                  id
                  occupation_type
                  occupation
                  monthly_income
                  name_of_Office_or_business
                  designation
                  job_length
                  verifyed
                  occupationAddress {
                    id
                    division
                    district
                    thana
                    office_area
                    address
                    postal_code
                  }
                }
                dependent {
                  id
                  number_of_child
                  number_of_dependent
                  verifyed
                  depandantDetails {
                    id
                    relation
                    name
                    age
                  }
                }
              }
            }
            product {
              id
              product
              status
            }
            user {
              id
              name
              phone
              email
              status
              ekyc {
                id
                phone
                nid
                email
                status
                parsonal {
                  id
                  name
                  last_name
                  father_name
                  mother_name
                  spouse_name
                  age
                  marital_status
                  gender
                  head_of_household
                  education_level
                  nid
                  nid_front
                  nid_back
                  photo
                  verifyed
                  nid_photo
                }
                contact {
                  id
                  mobile
                  other_phone
                  email
                  verifyed
                  presentAddress {
                    id
                    division
                    district
                    thana
                    address
                    near_landmark
                    postal_code
                    house_hold_type
                    living_in_this_address
                  }
                  permanentAddress {
                    id
                    pdivision
                    pdistrict
                    pthana
                    paddress
                    pnear_landmark
                    ppostal_code
                    phouse_hold_type
                    pliving_in_this_address
                    address_frm_nid
                  }
                }
                occupation {
                  id
                  occupation_type
                  occupation
                  monthly_income
                  name_of_Office_or_business
                  designation
                  job_length
                  verifyed
                  occupationAddress {
                    id
                    division
                    district
                    thana
                    office_area
                    address
                    postal_code
                  }
                }
                dependent {
                  id
                  number_of_child
                  number_of_dependent
                  verifyed
                  depandantDetails {
                    id
                    relation
                    name
                    age
                  }
                }
              }
            }
            notifications{
              id
              description
            }
          }
        }
      `,
        variables () {
          return {
            id: this.$route.params.applicationId
          }
        },
        update: (data) => data.purchase
      }
    },
    computed: {
      validateForm () {
        console.log("validate", this.guarantorList)
        return (
          !this.errors.any() &&
          this.appPersonalV === true &&
          this.appContactV === true &&
          /*this.appOccupationV === true &&*/ // commented due to occupation information missing
          this.appDependentV === true &&
          this.gOnePerInfoV === true &&
          this.gOneContactInfoV === true &&
          /*this.gOneOccuInfoV === true &&*/
          this.gOneDependentInfoV === true &&
          this.gTwoPerInfoV === true &&
          this.gTwoContactInfoV === true &&
          /*this.gTwoOccuInfoV === true &&*/
          this.gTwoDependentInfoV === true
        )
      },
      isDisabled() {

        /*if(this.invoice !=='' && this.articleSerialNo !=='' && this.article !==''){*/ // according to razib bhai invoice number not necessary
        if(this.articleSerialNo !=='' && this.article !==''){
          return false
        }else return true
      }
    },
    watch: {
      purchase (value) {
        if (value !== null) {
          this.$apollo.queries.purchase.refetch()
          this.purchaseApp = value

          this.product = this.purchaseApp.product
          this.user = value.user
          this.guarantor = value.guarantors[0]
          this.guarantorSec = value.guarantors[1]
          this.applicant = value.user.ekyc
          this.personal = value.user.ekyc.parsonal
          this.contact = value.user.ekyc.contact
          this.presentAddress = value.user.ekyc.contact.presentAddress
          this.parmanentAddress = value.user.ekyc.contact.permanentAddress
          this.occupation = value.user.ekyc.occupation
          if(this.occupation.hasOwnProperty('job_length')){
            var ar = this.occupation.job_length.split(',')
            this.userJobLYear = ar[0]
            this.userJobLMonth = ar[1]
          }
          console.log("Varifyed Chaek ===>> :", this.purchaseApp);
          this.occuAddress = value.user.ekyc.occupation.occupationAddress
          this.dependent = value.user.ekyc.dependent
          this.depandantDetails = value.user.ekyc.dependent.depandantDetails
          this.appPersonalV = this.purchaseApp.user.ekyc.parsonal.verifyed;
          this.appContactV = this.purchaseApp.user.ekyc.contact.verifyed;
          this.appOccupationV = this.purchaseApp.user.ekyc.occupation.verifyed;
          this.appDependentV = this.purchaseApp.user.ekyc.dependent.verifyed;
          this.gOnePerInfoV = this.guarantor.ekyc.parsonal.verifyed
          this.gOneContactInfoV = this.guarantor.ekyc.contact.verifyed
          this.gOneOccuInfoV = this.guarantor.ekyc.occupation.verifyed
          this.gOneDependentInfoV = this.guarantor.ekyc.dependent.verifyed
          console.log("===========>>>>>>>", this.guarantorSec);
          this.gTwoPerInfoV = this.guarantorSec.ekyc.parsonal.verifyed
          this.gTwoContactInfoV = this.guarantorSec.ekyc.contact.verifyed
          this.gTwoOccuInfoV = this.guarantorSec.ekyc.occupation.verifyed
          this.gTwoDependentInfoV = this.guarantorSec.ekyc.dependent.verifyed

          if (this.purchaseApp.notifications !== null) {
            this.note = this.purchaseApp.notifications[0].description
          }
        }
        console.log('purchase by Id: ', value)
        this.applications = value
      }
    },
    methods: {
      // Find Article No
      async findArticle (article) {
        console.log('Update :', this.article)
        await this.$apollo.query({
          query: productMaster,
          variables: {
            article: article
          }
        }).then((data) => {
          console.log('Data Article = ', data)
          this.articleDetail = data.data.productMaster
        })
      },
      //Accept Application
      async finalAcceptAppl () {
        await this.$apollo.mutate({
          mutation: acceptReject,
          variables: {
            id: this.purchaseApp.id,
            product_master_id: this.articleDetail.id,
            serial_number: this.articleSerialNo,
            invoice_number: null,
            status: 'ACCEPT'
          }
        }).then((data) => {
          this.popupActive2 = false
          console.log('Data Accept = ', data)
          this.$router.push('/hire_agreement/' + this.$route.params.applicationId).catch(() => {
          })
        })
      },
      //Reject Application
      async rejectApplication () {
        await this.$apollo.mutate({
          mutation: rejectAppplication,
          variables: {
            id: this.purchaseApp.id,
            status: 'REJECT'
          }
        }).then((data) => {
          this.$vs.notify({
            title: 'Rejected',
            text: 'Successfully Rejected',
            color: "danger",
            position: 'top-right'
          })
          this.$router.push('/showroomDashboard').catch(() => {})
          console.log('Data Reject = ', data)
        })
      },
      //Application Save Start Here
      async saveApplication () {
        this.verifyList = [
          {
            ekyc_id: this.purchaseApp.user.ekyc.id,
            personal: this.appPersonalV === true? true :false,
            contact: this.appContactV === true? true : false,
            occupation: this.appOccupationV ===  true? true : false,
            dependent: this.appDependentV ===  true? true : false,
          },
          {
            ekyc_id: this.purchaseApp.guarantors[0].ekyc.id,
            personal: this.gOnePerInfoV === true? true :false,
            contact: this.gOneContactInfoV === true? true :false,
            occupation: this.gOneOccuInfoV === true? true :false,
            dependent: this.gOneDependentInfoV === true? true :false,
          },
          {
            ekyc_id: this.purchaseApp.guarantors[1].ekyc.id,
            personal: this.gTwoPerInfoV === true? true :false,
            contact: this.gTwoContactInfoV === true? true :false,
            occupation: this.gTwoOccuInfoV === true? true :false,
            dependent: this.gTwoDependentInfoV === true? true :false,
          }
        ]
        if (this.purchaseApp !== null) {
          await this.$apollo.mutate({
            mutation: saveApplication,
            variables: {
              id: this.purchaseApp.id,
              verify: this.verifyList.map(v => {
                return {
                  ekyc_id: v.ekyc_id,
                  personal: v.personal,
                  contact: v.contact,
                  occupation: v.occupation,
                  dependent: v.dependent
                }
              }),
              note: this.note
            }
          }).then((data) => {
            console.log('Dep Data = ', data)
            this.$router.push('/showroomDashboard').catch(() => {})
          }).catch((error) => {
          })
        }
      },
      //Application Save End Here
      //Application Halt Start Here
      async haltApplication () {
        this.verifyList = [
          {
            ekyc_id: this.purchaseApp.user.ekyc.id,
            personal: this.appPersonalV === true? true :false,
            contact: this.appContactV === true? true : false,
            occupation: this.appOccupationV ===  true? true : false,
            dependent: this.appDependentV ===  true? true : false,
          },
          {
            ekyc_id: this.purchaseApp.guarantors[0].ekyc.id,
            personal: this.gOnePerInfoV === true? true :false,
            contact: this.gOneContactInfoV === true? true :false,
            occupation: this.gOneOccuInfoV === true? true :false,
            dependent: this.gOneDependentInfoV === true? true :false,
          },
          {
            ekyc_id: this.purchaseApp.guarantors[1].ekyc.id,
            personal: this.gTwoPerInfoV === true? true :false,
            contact: this.gTwoContactInfoV === true? true :false,
            occupation: this.gTwoOccuInfoV === true? true :false,
            dependent: this.gTwoDependentInfoV === true? true :false,
          }
        ]
        if (this.purchaseApp !== null) {
          await this.$apollo.mutate({
            mutation: haltApplication,
            variables: {
              id: this.purchaseApp.id,
              verify: this.verifyList.map(v => {
                return {
                  ekyc_id: v.ekyc_id,
                  personal: v.personal,
                  contact: v.contact,
                  occupation: v.occupation,
                  dependent: v.dependent
                }
              }),
              note: this.note
            }
          }).then((data) => {
            this.isHalt = false;
            this.$vs.notify({
              title: 'Halt',
              text: 'Successfully Halt this application',
              color: "danger",
              position: 'top-right'
            })
            this.$router.push('/showroomDashboard').catch(() => {})
            console.log('Dep Data = ', data)
          }).catch((error) => {
            this.isHalt = true;
          })
        }
      },
      //Application Halt End Here
      updatePersonalInfo (id, ekycId, purchaseId) {
        this.$router
          .push('/updatePersonalInfo/' + id + '/' + ekycId + '/' + purchaseId)
          .catch(() => {
          })
      },
      updateContactInfo (id, ekycId, purchaseId) {
        this.$router
          .push('/updateContactInfo/' + id + '/' + ekycId + '/' + purchaseId)
          .catch(() => {
          })
      },
      updateOccupationInfo (id, ekycId, purchaseId) {
        console.log('GID = ', id)
        this.$router
          .push('/updateOccupation/' + id + '/' + ekycId + '/' + purchaseId)
          .catch(() => {
          })
      },
      updateDependentInfo (id, ekycId, purchaseId) {
        this.$router
          .push('/updateDependant/' + id + '/' + ekycId + '/' + purchaseId + '/' + this.$route.params.applicationId)
          .catch(() => {
          })
      },
      getOrderStatusColor (status) {
        if (status === 'on_hold') return 'warning'
        if (status === 'delivered') return 'success'
        if (status === 'canceled') return 'danger'
        return 'primary'
      },
      getPopularityColor (num) {
        if (num > 90) return 'success'
        if (num > 70) return 'primary'
        if (num >= 50) return 'warning'
        if (num < 50) return 'danger'
        return 'primary'
      },
      guarantorPreviewById (id) {
        this.$router.push('/guarantorDetails/' + id).catch(() => {
        })
      }
    }
  }
</script>
<style>


   th {padding: 0}
  .vx-col table tr > td {
    /*vertical-align: top;*/
    min-width: 250px;
   /* word-break: break-all;*/
  }

  #page-user-view table td {
    /*vertical-align: top;*/
    min-width: 250px;
    /*word-break: break-all;*/
  }

  .nav-img-for-gu img {
    height: 55px;
    padding: 5px 0;
  }

  #user-data {
    padding: 15px 30px;
  }
  .img-container.mb-4 img {
    height: 130px;
  }
  img.nidImg {
    height: 130px;
    cursor: pointer;
  }
  img.nidImgPrev {
    height: 275px;
    width: auto;
    border-radius: 7px;
  }
  .custom-title{
     padding: 10px 20px;
    background: #fff;
    border-radius: 0.5rem;
    box-shadow: 0px 4px 25px 0px rgb(0 0 0 / 10%);
    -webkit-transition: all .3s ease-in-out;
  }
   @media only screen

   and (min-device-width: 375px)

   and (max-device-width: 768px)

   and (-webkit-min-device-pixel-ratio: 2)

   and (orientation: portrait) {
     #page-user-view table td {
       font-size: 9pt;
     }
     .vx-col table tr > td {
       min-width: auto;
     }

     #page-user-view table td {
       min-width: auto;
     }
   }

   @media only screen

   and (min-device-width: 375px)

   and (max-device-width: 768px)

   and (-webkit-min-device-pixel-ratio: 2)

   and (orientation: landscape) {
     #page-user-view table td {
       font-size: 9pt;
     }
   }
</style>
